/* minbox push events */

/* widgets positions */
export var MAIN_WIDGET_POSITION = 'main_site';
var pushToDashamail = function pushToDashamail(_ref) {
  var email = _ref.email;
  var _ref2 = window || {},
    dashamail = _ref2.dashamail;
  if (dashamail) {
    dashamail('async', {
      operation: 'UserSubscribe',
      data: {
        customer: {
          email: email,
          subscriptions: [{
            pointOfContact: 'Email',
            topic: 'General'
          }]
        },
        pointOfContact: MAIN_WIDGET_POSITION
      }
    });
  }
  return true;
};
export default pushToDashamail;